export enum ErpInvoiceState {
	Unvollstaendig = 10,
	Gueltig = 20,
	Bezahlt = 30,
	Storniert = 40,
}
